import App from './App.svelte';

const app = new App({
    target: document.body,
});

// // Check if user has seen the message already
// const hasSeenInstallPopup = localStorage.getItem("hasSeenInstallPopup");

// // Detects if device is on iOS 
// const isIos = () => {
//   const userAgent = window.navigator.userAgent.toLowerCase();
//   console.log(userAgent)
//   return /iphone|ipad|ipod|safari/.test( userAgent );
// }

// // Detects if device is in standalone mode
// const isInStandaloneMode = () => ('standalone' in window.navigator) && (window.navigator.standalone);

// // Checks if should display install popup notification:
// if (!hasSeenInstallPopup && isIos() && !isInStandaloneMode()) {
// //   showInstallMessage();
// //   localStorage.setItem("hasSeenInstallPopup", true);
// }


// if ("serviceWorker" in navigator) {
//     navigator.serviceWorker.register("./service-worker.js")
//         .then(async (registration) => {
//             console.log("Service Worker registered with scope:", registration.scope);
//             registration.periodicSync.register("update-news", {
//                 // try to update every 24 hours
//                 // minInterval: 24 * 60 * 60 * 1000,
//                 minInterval: 60 * 1000,
//             });
//             await registration.sync.register("sync-messages");
//         })
//         .catch((error) => {
//             console.error("Service Worker registration failed:", error);
//         });
        
// }


// // Request permission for push notifications
// Notification.requestPermission().then(permission => {
//     if (permission === 'granted') {
//       // Register for push notifications
//       return navigator.serviceWorker.ready.then(registration => {
//         return registration.pushManager.subscribe({
//           userVisibleOnly: true,
//           applicationServerKey: 'BF81cVSOjcVodxD0HLFKzLyd-XLHSN0ZI9cv6h3HkxJ2mxN2Z5x_E6NoWdae2xA2sZ6l1nOYtYKDe6xOHFapb_Q' // qq91K97vi00cG2RrFGsnmVzxvCmBBif-_5v5TmoEepE
//         });
//       });
//     }
// }).then(subscription => {
//     // Send the subscription information to your server for later use when sending push notifications
//     console.log(subscription)
// }).catch(error => {
//     console.error('Error requesting permission for push notifications:', error);
// });

  

export default app;
"https://fcm.googleapis.com/fcm/send/cyOekO4-KYE:APA91bFEMJP9_yooWtS_mwSfMSvlr1gwjXuL3Ovu19mnNVDAVk1QltTQULdG6X1rq_ogrs-5zPc7lW2fudP_iBrWCsE0ma2VtS8IYmDronAwA6RIYJ_pBOE-v5EMmQrXyuA62C2Fc0i-"
